import fetchClient from './fetchClient';
import { errorHandler } from "./utils";


const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const updateKanban = async (data: any) => {
    const res: any = await fetchClient
        .put(`/kanban`, data, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getKanban = async () => {
    const res: any = await fetchClient
        .get(`/kanban`, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};